import { Component, OnInit } from '@angular/core';
import { googlemaps } from 'googlemaps';
import * as $ from 'jquery';

@Component({
  template: ``
})
export class GmapLocation  implements OnInit  {
  map_marker;
  val;
  $el = null;
  $input = null;
  o = {};  
  ready = false;
  geocoder;// = false;
  map;// = false;
  maps = {};

  ngOnInit() {
    this.getCurrentLocation();
    //this.init();
  }

  locate() {      
    // reference
    let _this  = this;
    let _$el  = this.$el;
    
    // Try HTML5 geolocation
    if( ! navigator.geolocation ) {
      alert( 'Your Browser is not supporting Navigator!' );
      return this;
    }

    // show loading text
    _$el.find('.googlemap-search').val('Locating...');
    _$el.addClass('active');
    
    navigator.geolocation.getCurrentPosition(function(position) {       
      let lat = position.coords.latitude;
      let lng = position.coords.longitude;          
      _this.onSetMap({ $el : _$el }).update( lat, lng ).sync().center();
      
    });      
  }

  onSetMap( o ) {  
    // merge in new option
    $.extend( this, o );    
    
    // find input
    this.$input = this.$el.find('.value');  
    
    // get options
    this.o = this.get_atts( this.$el );

    // get map
    if( this.maps[ this.o['id'] ] ) {
      this.map = this.maps[ this.o['id'] ];
    }

    // return this for chaining
    return this;    
  }

  init() {      
    // geocode
    if( !this.geocoder ) {
      this.geocoder = new google.maps.Geocoder();
    }

    // google maps is loaded and ready
    this.ready = true;
    
    this.render();
  }

  render() {  
    //console.log('render');    
    // reference
    let _this  = this;
    let _$el  = this.$el;
    let args = {
        zoom    : parseInt(this.o['zoom']),
        center    : new google.maps.LatLng(this.o['lat'], this.o['lng']),
        mapTypeId  : google.maps.MapTypeId.ROADMAP,
        scrollwheel: false
    };

    // create map            
    this.map = new google.maps.Map( this.$el.find('.canvas')[0], args);
        
    // add search
    let autocomplete = new google.maps.places.Autocomplete( this.$el.find('.googlemap-search')[0]);
    
    autocomplete['map'] = this.map;
    //autocomplete.bindTo('bounds', this.map);
    
    // add dummy marker
    //   this.map_marker = new google.maps.Marker({
    //     draggable  : true,
    //     raiseOnDrag  : true,
    //     map      : this.map,
    // });

    this.map_marker = new google.maps.Marker({
      map      : this.map,
      position :  new google.maps.LatLng(this.o['lat'], this.o['lng']),
      draggable  : true
    });
    this.map_marker.setVisible( true );
    
    // add references
    this.map.$el = this.$el;      
      
    // value exists?
    let lat = this.$el.find('.input-lat').val();
    let lng = this.$el.find('.input-lng').val();
    
    if( !lat || !lng ) {
      lat = 53.331038;
      lng = -6.233250; 
    } 

    this.update( lat, lng ).center();
      
    // events
    google.maps.event.addListener(autocomplete, 'place_changed', function( e ) {
        
      // reference
      let $el = this.map.$el;

      // manually update address
      let address = $el.find('.googlemap-search').val();
      $el.find('.input-address').val( address );
      
      // vars
      let place = this.getPlace();
      //_this.onSetMap({ $el : $el }).getAddressComponentByPlace($el, place);
      // validate
      if( place.geometry ) {
        let lat = place.geometry.location.lat();
        let lng = place.geometry.location.lng();
                
        _this.onSetMap({ $el : $el }).update( lat, lng ).center();
      } else {
      // client hit enter, manulaly get the place
      _this.geocoder.geocode({ 'address' : address }, function( results, status ){
        
        // validate
        if( status != google.maps.GeocoderStatus.OK ) {
          console.log('Geocoder failed due to: ' + status);
          return;
        }
        
        if( !results[0] ) {
          console.log('No results found');
          return;
        }

        // get place
        place = results[0];
        
        let lat = place.geometry.location.lat();
        let lng = place.geometry.location.lng();
          
        //_this.onSetMap({ $el : $el }).update( lat, lng ).center();
            
        });

        // this.geocoder = new google.maps.Geocoder();
        // this.getAddress(address, $el);
      }   

    });

    google.maps.event.addListener( this.map_marker, 'dragend', function( e ){
        
      // reference
      let $el = this.map.$el;

      // let position = this.map_marker.getPosition();
      // let lat = position.lat();
      // let lng = position.lng();

      let lat = e.latLng.lat();
      let lng = e.latLng.lng();
          
      _this.onSetMap({ $el : $el }).update( lat, lng ).sync();
        
    });

    google.maps.event.addListener( this.map, 'click', function( e ) {
      
      // reference
      let $el = this.$el;
        
        
      // vars
      let lat = e.latLng.lat();
      let lng = e.latLng.lng();
      
      _this.onSetMap({ $el : $el }).update( lat, lng ).sync();
    
    });

    // add to maps
    this.maps[ this.o['id'] ] = this.map;        
  }

  getAddress(address, $el) {
    let $marker = $el.find('.marker');
    this.geocoder.geocode( { 'address': address }, function(results, status) {
      if (status == google.maps.GeocoderStatus.OK) {
          this.map.setCenter(results[0].geometry.location);
          this.marker = new google.maps.Marker({
              map: this.map,
              position: results[0].geometry.location
          });

          this.map.markers.push( this.marker );

          this.getAddress(address);

          // if marker contains HTML, add it to an infoWindow
          if($marker.html()) {
              // create info window
              var infowindow = new google.maps.InfoWindow({
                  content     : $marker.html()
              });

              // show info window when marker is clicked
              google.maps.event.addListener(this.marker, 'click', function() {
                  console.log("open info window");
                  infowindow.open( this.map, this.marker );
              });
          }
      } else {
          alert("Geocode was not successful for the following reason: " + status);
      }
    });
  }

  update( lat, lng ) {    
    // vars
    let latlng = new google.maps.LatLng( lat, lng );
      
    // update inputs
    this.$el.find('.input-lat').val( lat );
    this.$el.find('.input-lng').val( lng ).trigger('change');
    // jQuery("#land-coordinates").val(lat +','+lng);
    
    // update marker
    this.map_marker.setPosition( latlng );      
      
    // show marker
    this.map_marker.setVisible( true );
      
      
    // update class
    this.$el.addClass('active');

    // validation
    this.$el.closest('.field').removeClass('error');
    
    // return for chaining
    return this;
  }

  center() {      
    // vars
    let position = this.map_marker.getPosition();
    let lat = this.o['lat'];
    let lng = this.o['lng'];
    
    
    // if marker exists, center on the marker
    if( position ) {
      lat = position.lat();
      lng = position.lng();
    }
    
    let latlng = new google.maps.LatLng( lat, lng );      
    
    // set center of map
    this.map.setCenter( latlng );
  }
  
  sync() {   
    // reference
    let $el  = this.$el;
    
    // vars
    let position = this.map_marker.getPosition();
    let latlng = new google.maps.LatLng( position.lat(), position.lng() );
    
    
    this.geocoder.geocode({ 'latLng' : latlng }, function( results, status ) {
      
      // validate
      if( status != google.maps.GeocoderStatus.OK ) {
        console.log('Geocoder failed due to: ' + status);
        return;
      }
      
      if( !results[0] ) {
        console.log('No results found');
        return;
      }
      
      // get location
      let location = results[0];
      
      // update h4
      $el.find('.googlemap-search').val( location.formatted_address );
      
      // update input
      $el.find('.input-address').val( location.formatted_address ).trigger('change');
      
    });
    
    // return for chaining
    return this;
  }
    
  clear() {
    // update class
    this.$el.removeClass('active');
    
    // clear search
    this.$el.find('.googlemap-search').val('');
    
    
    // clear inputs
    this.$el.find('.input-address').val('');
    this.$el.find('.input-lat').val('');
    this.$el.find('.input-lng').val('');
    
    // hide marker
    this.map_marker.setVisible( false );
  }
  
  edit() {    
    // update class
    this.$el.removeClass('active');
    
    this.$el.find('.googlemap-search').val( this.val ).focus();    
  }
  
  refresh() {
    // trigger resize on div
    google.maps.event.trigger(this.map, 'resize');
    
    // center map
    this.center();
    
  }

  onClick( e ) {
    e.preventDefault();    
    //acf.fields.google_map.set({ $el : $(this).closest('.google-map-field') }).clear();    
    this.onBlur(e);
    
  }

  onKeydown( e ) {    
    // prevent form from submitting
    if( e.which == 13 ) {
        return false;
    }    
  }
  
  onBlur( e ) {    
    // vars
    let $el = $(this).closest('.google-map-field');   
    
    // has a value?
    if( $el.find('.input-lat').val() ) {
      $el.addClass('active');
    }
    
  }

  load_map(lat,lng) {
    let mapField;
    $(".google-map-field").each(function() {     
      mapField = { $el : $(this) };    
      $(this).find('.input-lat').val(lat);
      $(this).find('.input-lng').val(lng); 
    });  
    this.onSetMap(mapField).init();   
  }

  get_atts( $el ) {   
    let atts = {};    
    $.each( $el[0].attributes, function( index, attr ) {          
      if( attr.name.substr(0, 5) == 'data-' ) {
        atts[ attr.name.replace('data-', '') ] = attr.value;
      }
    });
        
    return atts;      
  }

  getCurrentLocation() {
    this.onSetMap({ $el : $(".google-map-field") }).locate();
  }

  getAddressComponentByPlace($el, place) { 
    let components = {}; 
    for(let address_component of place.address_components) { 
      for(let type of address_component.types) { 
        $el.find('.input-' + type).val(address_component.long_name)
      }; 
    }; 
  }
}


// WEBPACK FOOTER //
// ./src/app/library/location-map/lib/GmapLocation.ts